/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { AxiosInstance } from "axios"
// import AxiosDefault from "axios/lib/defaults"
import { getAcceptLanguageCode } from "utils/i18n"
import { http401UnauthorizedHandler } from "utils/network"
// import { wrapError } from "utils/wrapError"
// import JSONbigint from "json-bigint"
// import { captureException } from "@sentry/react"

/*
  Instead of put axios interceptors inside store.ts it's better to put the interceptor here.
  Both of requestInterceptor and responseInterceptor function makes the code being testable
  inside store.ts without break the original mechanism

  Both of function below can be tested too
*/
export const requestInterceptor = (axiosClient: AxiosInstance) => {
  axiosClient.interceptors.request.use(
    config => {
      const modifiedConfig = { ...config }
      modifiedConfig.headers = config.headers?.concat({
        "Accept-Language": getAcceptLanguageCode(false),
      })

      /**
       * request interceptor, preventing the response the default behaviour of parsing the response with JSON.parse
       * @see https://stackoverflow.com/questions/43787712/axios-how-to-deal-with-big-integers
       */

      // modifiedConfig.transformResponse = [
      //   data => {
      //     try {
      //       return JSONbigint.parse(data)
      //     } catch (error) {
      //       // only send error to sentry if data is not empty
      //       if (data) {
      //         // edge case, bigint lib might throw an object instead of an error...
      //         const errorToSend = wrapError(error)
      //         captureException(errorToSend, {
      //           tags: {
      //             oncallHandle: "@oncall-food-cms-fe",
      //             serviceName: "food-merchant-portal",
      //             from: "requestInterceptor",
      //             url: config?.url,
      //             data,
      //           },
      //         })
      //       }
      //       // use default axios transformResponse as fallback
      //       return AxiosDefault.transformResponse[0](data)
      //     }
      //   },
      // ]

      return modifiedConfig
    },
    error => {
      return Promise.reject(error)
    },
  )
}

export const responseInterceptor = (
  axiosClient: AxiosInstance,
  isDev: boolean,
) => {
  axiosClient.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401 && !isDev) {
        http401UnauthorizedHandler()
      }
      return Promise.reject(error)
    },
  )
}
